import { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGrid } from '@rtkwlf/pro-solid-svg-icons/faGrid';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@packages/fenrir/components/icon-button';
import { ListItemText } from '@packages/fenrir/components/list';
import { Menu } from '@packages/fenrir/components/menu';
import { MenuItem } from '@packages/fenrir/components/menu-item';
import { Tooltip } from '@packages/fenrir/components/tooltip';

export type AppSwitchMenuItem = { text: string; href: string };

export type AppSwitchMenuProps = {
  menuItems: AppSwitchMenuItem[];
};

export const AppSwitchMenu = ({ menuItems }: AppSwitchMenuProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'appBar.appSwitch' });

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {/* tooltip title adds an aria-label on the children tag */}
      <Tooltip title={t('title')}>
        <IconButton
          color="default"
          id="appbar-switch-app"
          onClick={handleClick}
          size="small"
        >
          <FontAwesomeIcon icon={faGrid} />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'appbar-switch-app',
            dense: true,
          },
        }}
      >
        {menuItems.map((item) => (
          <MenuItem
            key={item.text}
            component="a"
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ListItemText>{item.text}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
